import { createRouter, createWebHashHistory } from 'vue-router';
import { getEditing, getShowDialogEditManager, getUser, openDialogEditManager } from './main';
import { getKeycloak, isAuthenticated } from './service/KeycloakService';

const PENDING_AUTH_ROUTE_STORAGE_KEY = 'selectio.pending-auth-route';

const routes = [
  {
    path: '/landing-page',
    name: 'landingpage',
    component: () => import('./pages/LandingPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    name: 'dashboard',
    exact: true,
    component: () => import('./components/Dashboard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_geographic',
    name: 'riskgeographic',
    component: () => import('./components/AnalisiRischi/AreeGeografiche.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_sectors',
    name: 'risksectors',
    component: () => import('./components/AnalisiRischi/Settori.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/payments',
    name: 'payments',
    component: () => import('./components/AnalisiRischi/Payments.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/economics',
    name: 'economics',
    component: () => import('./components/AnalisiRischi/Economics.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/buyers_list',
    name: 'buyerslist',
    component: () => import('./components/Buyers/BuyersList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/create_portfolio',
    name: 'createportfolio',
    component: () => import('./components/Admin/Portfolio/CreatePortfolio2.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/manage_portfolio',
    name: 'manageportfolio',
    component: () => import('./components/Admin/Portfolio/ManagePortfolio2.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/manage_unmatched_buyers',
    name: 'manageunmatchedbuyers',
    component: () => import('./components/Admin/ManageUnmatchedBuyers.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/gestione_acquisti',
    name: 'gestioneacquisti',
    component: () => import('./components/Admin/GestioneAcquisti.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('./components/Admin/Statistics.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/SFTP',
    name: 'SFTP',
    component: () => import('./components/Admin/SFTP.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/manage_api_contracts',
    name: 'manageapicontracts',
    component: () => import('./components/Admin/ManageApiContracts.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/providers',
    name: 'providers',
    component: () => import('./components/Admin/providers/provider/Provider.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/provider-contracts',
    name: 'providerContracts',
    component: () => import('./components/Admin/providers/contracts/ProviderContracts.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/icon-staging',
    name: 'iconStaging',
    component: () => import('./components/Admin/providers/provider/IconStaging.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/provider-staging',
    name: 'providerStaging',
    component: () => import('./components/Admin/providers/provider/ProviderStaging.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/provider-feed',
    name: 'providerFeed',
    component: () => import('./components/Admin/providers/provider/ProviderFeed.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/manage_buyer_exclusions',
    name: 'managebuyerexclusions',
    component: () => import('./components/Admin/ManageBuyerExclusions.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/icon_demo',
    name: 'icondemo',
    beforeEnter() {
      const token = getUser()?.token || getKeycloak().token;
      sessionStorage.setItem('icon-demo-security', token);
      window.location.replace('https://coface.storylane.io/share/9rtiil3hxndw?elqTrackId=D4B2D51866BF49A0B382B25DF7D263A3&elqTrack=true');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/insured_demo',
    name: 'insureddemo',
    beforeEnter() {
      window.location.replace('https://cofssl.coface.com/Selectio/insured/0.html');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/lista_portafogli',
    name: 'listaportafogli',
    component: () => import('./components/Admin/ListaPortafogli.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    exact: true,
    component: () => import('./components/Notifications.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/userpreference',
    name: 'userpreference',
    exact: true,
    component: () => import('./components/UserPreference.vue'),
    meta: {
      requiresAuth: true,
      editable: true,
    },
  },
  {
    path: '/tars',
    name: 'TARS',
    exact: true,
    component: () => import('./components/Tars.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  if (!to.name && to.path !== '/') {
    next({ path: '/' });
    return;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (getShowDialogEditManager() !== true && from.meta != null && from.meta.editable === true && getEditing() === true) {
      openDialogEditManager(from.fullPath);
    }
    if (!isAuthenticated()) {
      const pendingRoute = to.fullPath || to.path || '/';
      if (pendingRoute !== '/' && pendingRoute !== '/landing-page') {
        sessionStorage.setItem(PENDING_AUTH_ROUTE_STORAGE_KEY, pendingRoute);
      } else {
        sessionStorage.removeItem(PENDING_AUTH_ROUTE_STORAGE_KEY);
      }
      next(false);
      getKeycloak().login({ redirectUri: window.location.href });
      return;
    }
  }
  next();
});

export default router;
